import { useEffect, useRef } from "react";
import { readUpdateStream } from "../utils/updateStreamReader";

/**
 * React hook wrapper over readUpdateStream: opens the connection in an effect keyed on the
 * request shape, forwards frames to onUpdate via a stable ref, and aborts on unmount. A null
 * request means idle (no connection); the stream re-opens whenever the request changes.
 * @param {object} params
 * @param {{ url: string, method?: string, body?: object, headers?: object } | null} params.request
 * @param {(frame: object) => void} params.onUpdate
 */
const useUpdateStream = ({ request, onUpdate }) => {
  const onUpdateRef = useRef(onUpdate);
  onUpdateRef.current = onUpdate;

  const { url, method = "POST", body, headers } = request || {};

  useEffect(() => {
    if (!url) return undefined;
    const controller = new AbortController();

    readUpdateStream({
      url,
      method,
      body,
      headers,
      onUpdate: (frame) => onUpdateRef.current(frame),
      signal: controller.signal
    }).catch((error) => {
      if (error.name !== "AbortError") console.error("[useUpdateStream] stream failed", error);
    });

    return () => controller.abort();
  }, [url, method, JSON.stringify(body), JSON.stringify(headers)]);
};

export default useUpdateStream;
